"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialWeblabState = void 0;
exports.initialWeblabState = {
    weblabTreatments: {}
};
